import React from "react";

const Spinner = () => (
  <span className="inline-block size-5 animate-spin rounded-full border-2 border-lineStrong border-t-primary" />
);

export default Spinner;
